<template>
  <div class="caption">
    <div v-for="d in barData" :key="d.key">
      <div class="bar-label">
        {{ d.label }}
      </div>
      <div
        :style="{
          height: `${barHeight}px`,
          margin: `${$vuetify.rtl ? '0 0 12px 48px' : '0 48px 12px 0'}`
        }"
        class="bar-container"
      >
        <div
          :style="{
            'background-color': $vuetify.theme.themes.light.secondary
          }"
          class="bar-bg"
        ></div>
        <div
          :style="{
            width: `${d.value * 100}%`,
            'background-color': d.color,
            [`${$vuetify.rtl ? 'right' : 'left'}`]: 0
          }"
          class="bar-fg"
        ></div>
        <div
          :style="{
            [`${$vuetify.rtl ? 'right' : 'left'}`]: `${d.value * 100}%`,
            'line-height': `${barHeight}px`
          }"
          class="bar-value"
        >
          {{ d.formated }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { scaleLinear } from "d3-scale";
export default {
  props: {
    barData: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      barHeight: 16
    };
  },
  computed: {
    x() {
      return scaleLinear()
        .domain([0, 1])
        .range([0, 100]);
    }
  }
};
</script>

<style scoped>
.bar-container {
  position: relative;
  margin-bottom: 8px;
}

.bar-bg {
  height: 100%;
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

.bar-fg {
  height: 100%;
  position: absolute;
  top: 0;
}

.bar-value {
  position: absolute;
  padding: 0 4px;
}
</style>